import type { AnnualStatementStatus } from "@fideus-core/annual-statement";
import { annualStatementStatusSchema } from "@fideus-core/annual-statement";
import type { ServiceTaskType } from "@fideus-core/service-task";
import { serviceTaskTypeSchema } from "@fideus-core/service-task";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod/v4";
import { AnnualStatementProcessesPage } from "../../annualStatementProcesses/AnnualStatementProcessesPage";

const processFilterValues = [
  "alle",
  "kundenaufgaben",
  "fallvorbereitung",
  "fallBuchen",
  "datenUebertrag",
  "offenlegen",
  "offenlegungPruefen",
  "sonderfaelle",
  "mitFinanzamtKlaeren",
  "beiTechTax",
  "anTechTaxUebergeben",
] as const;

type ProcessFilter = (typeof processFilterValues)[number];

const searchSchema = z.object({
  filter: z.enum(processFilterValues).default("alle"),
  annualStatementStatus: annualStatementStatusSchema.optional(),
  serviceTaskType: serviceTaskTypeSchema.optional(),
});

export const Route = createFileRoute("/vorgaenge/")({
  validateSearch: zodValidator(searchSchema),
  loader: async ({ context: { queryClient, trpc } }) => {
    void queryClient.ensureQueryData(
      trpc.annualStatements.listAnnualStatementProcesses.queryOptions({})
    );
    void queryClient.ensureQueryData(trpc.listUsers.queryOptions());
  },
  component: VorgaengeRoute,
});

function VorgaengeRoute() {
  const navigate = useNavigate();
  const { filter, annualStatementStatus, serviceTaskType } = Route.useSearch();

  const setFilter = (newFilter: ProcessFilter) => {
    navigate({
      to: "/vorgaenge",
      search: (prev) => ({ ...prev, filter: newFilter }),
    });
  };

  const setAnnualStatementStatus = (
    newStatus: AnnualStatementStatus | undefined
  ) => {
    navigate({
      to: "/vorgaenge",
      search: (prev) => ({ ...prev, annualStatementStatus: newStatus }),
    });
  };

  const setServiceTaskType = (newType: ServiceTaskType | undefined) => {
    navigate({
      to: "/vorgaenge",
      search: (prev) => ({ ...prev, serviceTaskType: newType }),
    });
  };

  return (
    <AnnualStatementProcessesPage
      filter={filter}
      onFilterChange={setFilter}
      annualStatementStatus={annualStatementStatus}
      onAnnualStatementStatusChange={setAnnualStatementStatus}
      serviceTaskType={serviceTaskType}
      onServiceTaskTypeChange={setServiceTaskType}
    />
  );
}
